<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <pageheader :page-name="pageName" parent-page-name="C1868" parent-page-url="/1868s" />
      <add-edit-form
        v-if="model"
        returnUrl="/1868s"
        :apiBaseUrl="API_BASE_URL"
        :model="model"
        :fields="fields"
        :toEdit="toEdit"
      />
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
import Pageheader from '@/components/Pageheader.vue'
import AddEditForm from '@/components/AddEditForm.vue'
import C1868 from '@/models/C1868'
/* eslint-disable no-undef */
export default {
  name: 'AddC1868',
  components: {
    Pageheader,
    AddEditForm
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    },
    pageName () {
      return this.toEdit ? 'Edit 1868' : 'Add 1868'
    },
    categoryOptions () {
      if (this.model.category_id == this.PRODUCT_1868_CATEGORY_ID) { // eslint-disable-line
        return [
          {id: 'Hard Cider', name: 'Hard Cider'},
          {id: 'Imperial Hard Cider', name: 'Imperial Hard Cider'},
          {id: 'Mango Hard Cider', name: 'Mango Hard Cider'},
          {id: 'Berry Blush Cider', name: 'Berry Blush Cider'}
        ]
      }
    },
    fields () {
      let fields = [
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Sort number', key: 'sort_no', type: 'number' },
        { label: 'PSD Format', key: 'PSD', type: 'format' },
        { label: 'EPS Format', key: 'EPS', type: 'format' },
        { label: 'PNG Format', key: 'PNG', type: 'format' },
        { label: 'PDF Format', key: 'PDF', type: 'format' },
        { label: 'JPG Format', key: 'JPG', type: 'format' },
        { label: 'Word Format', key: 'WORD_DOC', type: 'format' },
        { label: 'AI Format', key: 'AI', type: 'format' },
        { label: 'XLS Format', key: 'XLS', type: 'format' },
        { label: 'All Formats', key: 'ALL', type: 'format' }
      ]

      fields.splice(3, 0, { label: 'Category', key: 'category_id', type: 'select', options: this.categories })

      if (this.model.category_id == this.PRODUCT_1868_CATEGORY_ID) { // eslint-disable-line
        fields.push({ label: 'Sub Category', key: 'sub_category', type: 'select', options: this.categoryOptions })
      }

      return fields
    }
  },
  data () {
    return {
      API_BASE_URL: 'c1868',
      model: null,
      PRODUCT_1868_CATEGORY_ID: process.env.PRODUCT_1868_CATEGORY_ID,
      categories: []
    }
  },
  mounted () {
    this.fetchAllCategories()
    if (this.toEdit) {
      this.fetch()
    } else {
      this.model = new C1868()
    }
  },
  methods: {
    fetchAllCategories () {
      this.$store.dispatch('fetchAllC1868Categories')
        .then((result) => {
          if (!result.data.categories.length) {
            this.$router.push('/c1868-categories')
            this.$toast.error('Please create categories first')
          }
          this.categories = result.data.categories
          // this.fields.splice(3, 0, { label: 'Category', key: 'category_id', type: 'select', options: result.data.categories })
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    fetch () {
      this.$store.dispatch(this.API_BASE_URL + '/get', this.$route.params.id)
        .then((result) => {
          this.model = new C1868(result.c1868)
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/C1868s/AddEdit.vue